import { useState } from "react";
import { useMutation, useQuery } from "convex/react";
import { api } from "../../../convex/_generated/api";
import { useProject } from "@/hooks/project";
import { Button, PageHeader, useRun } from "@/components/ui";
import { LibraryView } from "../Library";

export function ProjectChains() {
  const { project, canEdit, isAdmin } = useProject();
  const [tab, setTab] = useState<"chains" | "milestones" | "docTypes" | "refs">("milestones");
  const lib = useQuery(api.library.list, {});
  const loadDefaults = useMutation(api.library.loadDefaults);
  const run = useRun();
  const empty = lib && lib.chains.length === 0;
  return (
    <div className="max-w-6xl">
      <PageHeader title="Chains & milestones" sub="Milestones, chains and document types from the organisation library. Customize a chain to give this project its own copy (it shows a 'differs' badge), or pull just the items this project needs." />
      {empty && (
        <div className="mb-4 flex items-center justify-between gap-3 rounded-lg border border-brand-100 bg-brand-50 p-4 text-sm text-brand-700">
          <span>The organisation library is empty. Load the default milestones and chains (your MS Definition List and MS Chain Definition) to start from them.</span>
          {isAdmin && (
            <Button variant="primary" onClick={() => run(() => loadDefaults({}), "Default library loaded")}>
              Load default library
            </Button>
          )}
        </div>
      )}
      <LibraryView projectId={project._id} tab={tab} onTab={setTab} canEdit={canEdit} />
    </div>
  );
}
